import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'

export const getVATSettings = async (app) => {
  let vat_settings = null

  app.startLoadingIndicator("Reading VAT settings")
  await trackPromise (
    axios.get(app.API_URI + `/settings?user_id=global&field=vat`)
      .then(result => {
        vat_settings = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
  )
  return vat_settings
}

export const saveVATSettings = async (app, vat_settings) => {
  let save_vat_settings = false

  app.startLoadingIndicator("Updating VAT Settings")
  await trackPromise (
    axios.put(app.API_URI + `/settings?user_id=global&field=vat`, vat_settings)
      .then(result => {
          save_vat_settings = result.data
          app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
  )
  return save_vat_settings
}

export const getWarehouseById = async (app, warehouse_id) => {
  let warehouse = null

  app.startLoadingIndicator("Getting warehouse")
  await trackPromise (
    axios.get(app.API_URI + `/warehouses?warehouse_id=${warehouse_id}`)
    .then(result => {
      warehouse = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return warehouse
}

export const saveWarehouse = async (app, warehouse) => {
  let save_warehouse = null

  app.startLoadingIndicator("Saving warehouses")
  if (!warehouse._id)
    await trackPromise (
      axios.post(app.API_URI + '/warehouses', warehouse)
      .then(result => {
        save_warehouse = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  else
    await trackPromise (
      axios.put(app.API_URI + `/warehouses?warehouse_id=${warehouse._id}`, warehouse)
      .then(result => {
        save_warehouse = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )

  return save_warehouse
}

export const deleteWarehouse = async (app, warehouse_id) => {
  let delete_warehouse = null

  app.startLoadingIndicator("Deleting warehouse")
  await trackPromise (
    axios.delete(app.API_URI + `/warehouses?warehouse_id=${warehouse_id}`)
    .then(async result => {
      delete_warehouse = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )

  return delete_warehouse
}

export const getWarehouses = async (app) => {
    let warehouses = null 

    app.startLoadingIndicator()
    await trackPromise (
      axios.get(app.API_URI + '/warehouses')
      .then(result => {
          warehouses = result.data
          app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
    return warehouses
}